export default __webpack_public_path__ + "1ed4ecdcdf8e6604add62985ab874a49.svg";